import gql from 'graphql-tag';

export const SET_DEFAULTS_FOR_ACCOUNT = gql`
  mutation SetDefaultsForAccount {
    bpf {
      result: setDefaultsForAccount {
        error
        success
        entity
      }
    }
  }
`;
